import React from 'react';
import { motion } from 'framer-motion';

const TermsOfService = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  const contactBlock = (
    <div className="bg-[#F9FFF5] border border-[#2E7D32]/20 p-6 rounded-lg mt-2">
      <p><strong>Sam's Nutri Hub</strong></p>
      <p>Venkatesh Prime, 4th Floor, Burudgaon Road</p>
      <p>Ahmednagar, Maharashtra 414001</p>
      <p>Email: <a href="mailto:hello@samsnutrihub.com" className="text-[#2E7D32] hover:underline">hello@samsnutrihub.com</a></p>
      <p>Phone: <a href="tel:+919637375555" className="text-[#2E7D32] hover:underline">+91 96373 75555</a></p>
    </div>
  );

  return (
    <div className="bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <motion.div {...fadeInUp}>
          <p className="text-sm text-[#9E9E9E] mb-2">Last updated: November 1, 2023</p>
          <h1 className="text-4xl font-bold text-[#0B1320] font-poppins mb-10">
            Terms &amp; Conditions — Sam's Nutri Hub
          </h1>

          <div className="prose prose-lg max-w-none text-[#4A4A4A] leading-relaxed space-y-8">

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">1. Introduction</h2>
              <p>
                Welcome to Sam's Nutri Hub ("we", "our", or "us"). By accessing the website at{' '}
                <a href="https://samsnutrihub.com" target="_blank" rel="noopener noreferrer" className="text-[#2E7D32] hover:underline">
                  https://samsnutrihub.com
                </a>
                , you agree to be bound by these Terms and Conditions, all applicable laws and regulations, and
                agree that you are responsible for compliance with any applicable local laws. If you do not agree
                with any of these terms, you are prohibited from using or accessing this site.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">2. Account Registration</h2>
              <p>
                Accounts may be created to access our free weight loss live sessions and to join our free wellness
                community. To register, you must provide your name, email address, and other relevant details.
                Failure to provide complete and accurate information may result in termination of your account.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">3. Age Restrictions</h2>
              <p>
                Our services are available only to individuals who are 13 years of age or older. By using our
                services, you represent that you are at least 13 years old. Users under 13 are not permitted
                to use our platform.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">4. Content Access and Use</h2>
              <p>
                Registered users may access our group communities, daily stories, posts, images, videos, forum
                knowledge base, and live webinars. You are granted a limited, non-transferable license to access
                and make personal use of the content on our website. This license does not include any resale or
                commercial use of our content or any derivative use thereof.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">5. User-Generated Content</h2>
              <p>
                Users may contribute content in our community section (similar to a private health and wellness
                group) and during webinar engagement such as Q&amp;A sessions and comment threads. You are
                responsible for all content you upload or post. By contributing content, you grant us a
                non-exclusive, royalty-free license to use, display, and distribute your content within our
                platform.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">6. Intellectual Property</h2>
              <p>
                All content, trademarks, and data on this website — including but not limited to software,
                databases, text, graphics, icons, and hyperlinks — are the property of Sam's Nutri Hub or
                licensed to us and are protected by domestic and international intellectual property laws.
                Unauthorised reproduction or redistribution is strictly prohibited.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">7. Governing Law</h2>
              <p>
                These Terms and Conditions are governed by and construed in accordance with the laws of Bharat
                (India), and you irrevocably submit to the exclusive jurisdiction of the courts of Maharashtra
                in that country.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">8. Amendments</h2>
              <p>
                These Terms and Conditions may be updated periodically. It is your responsibility to check for
                updates. Continued use of our services after any changes constitutes your acceptance of the
                revised terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">9. Termination</h2>
              <p>
                We reserve the right to terminate or suspend your account and access to our services without
                notice, for conduct that we believe violates these Terms, is harmful to other users, or for
                any other reason at our sole discretion.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">10. Limitation of Liability</h2>
              <p>
                In no event shall Sam's Nutri Hub, nor its directors, employees, partners, agents, suppliers,
                or affiliates, be liable for any indirect, incidental, special, consequential, or punitive
                damages — including without limitation, loss of profits, data, use, goodwill, or other
                intangible losses — resulting from your access to or inability to access or use the services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#0B1320] font-poppins mb-3">11. Contact Us</h2>
              <p>For any questions about these Terms, please contact us:</p>
              {contactBlock}
            </section>

          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsOfService;